import { set, map, pick } from 'lodash/fp';
import { ASSIGN } from 'constants/actionTypes';
import { routes, EVENTS } from 'constants/config';
import request from 'utils/request_ajax';
import { buildAssignment } from './helpers';
import { isAssignee } from '../../reducers/assign';

export const actions = {
  activeStep: step => ({
    type: ASSIGN.STEP.SET_ACTIVE,
    step,
  }),
  resetData: () => ({
    type: ASSIGN.DATA.RESET,
  }),
  requestData: () => ({
    type: ASSIGN.DATA.REQUEST,
  }),
  requestNextPageSuccess: payload => ({
    type: ASSIGN.DATA.REQUEST_NEXT_PAGE_SUCCESS,
    payload,
  }),
  requestDataSuccess: payload => ({
    type: ASSIGN.DATA.REQUEST_SUCCESS,
    payload,
  }),
  updateQuery: query => ({
    type: ASSIGN.PARAMS.UPDATE_QUERY,
    query,
  }),
  updateSort: option => ({
    type: ASSIGN.PARAMS.UPDATE_SORT,
    option,
  }),
  updateType: values => ({
    type: ASSIGN.PARAMS.UPDATE_FILTER_TYPE,
    values,
  }),
  selectItem: item => ({
    type: ASSIGN.ITEM.SELECT,
    item,
  }),
  deselectItem: item => ({
    type: ASSIGN.ITEM.DESELECT,
    item,
  }),
  setAssigneesCount: count => ({
    type: ASSIGN.ITEM.SET_ASSIGNEES_COUNT,
    count,
  }),
  updateSchedule: changes => ({
    type: ASSIGN.SCHEDULE.UPDATE,
    changes,
  }),
  updateExistingAssignmentOption: option => ({
    type: ASSIGN.REVIEW.UPDATE_EXISTING_ASSIGNMENT_OPTION,
    option,
  }),
  updateMessage: body => ({
    type: ASSIGN.REVIEW.UPDATE_MESSAGE,
    body,
  }),
};

export function setActiveStep(step) {
  return (dispatch, getState) => {
    dispatch(actions.activeStep(step));
  };
}

export function requestData(page = 1) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(actions.requestData());

      const { params, activeStep: step } = getState();

      request
        .get(routes.ASSIGNABLES[step], { page, ...params })
        .then(response => {
          if (page === 1) {
            dispatch(actions.requestDataSuccess(response));
          } else {
            dispatch(actions.requestNextPageSuccess(response));
          }
          resolve(response);
        });
    });
}

export function requestNextPage() {
  return (dispatch, getState) => {
    const { page } = getState().pagination;
    dispatch(requestData(page + 1));
  };
}

export function resetData(shouldRequest) {
  return (dispatch, getState) => {
    dispatch(actions.resetData());
    if (shouldRequest) dispatch(requestData());
  };
}

export function requestInitalData() {
  return dispatch => {
    dispatch(resetData());
    dispatch(requestData());
  };
}

export function updateParamQuery(query) {
  return (dispatch, getState) => {
    dispatch(actions.updateQuery(query));
    dispatch(requestData());
  };
}

export function updateParamSort(option) {
  return (dispatch, getState) => {
    dispatch(actions.updateSort(option));
    dispatch(requestData());
  };
}

export function updateParamFilterType(values) {
  return (dispatch, getState) => {
    dispatch(actions.updateType(values));
    dispatch(requestData());
  };
}

export function updateAssigneesCount() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const selectedData = getState().selection.assignees.data;
      const getIdentity = pick(['id', 'type']);
      const assignees = map(getIdentity, selectedData);

      request.get(routes.ASSIGNABLES.USER_COUNT, { assignees }).then(data => {
        dispatch(actions.setAssigneesCount(data.count));
      });
    });
}

export function toggleAssignableItem(item) {
  return (dispatch, getState) => {
    if (item.selected) {
      dispatch(actions.deselectItem(item));
    } else {
      item = set('selected', true)(item);
      dispatch(actions.selectItem(item));
    }

    if (isAssignee(item)) {
      dispatch(updateAssigneesCount());
    }
  };
}

export function updateSchedule(changes) {
  return (dispatch, getState) => {
    dispatch(actions.updateSchedule(changes));
  };
}

export function updateExistingAssignmentOption(option) {
  return (dispatch, getState) => {
    dispatch(actions.updateExistingAssignmentOption(option));
  };
}

export function submitAssignment() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const assignment = buildAssignment(getState);

      request
        .postJSON(routes.ASSIGNMENT_ASSIGN, assignment)
        .then(data => {
          if (data.success) {
            request.getScript(routes.NOTIFICATIONS_LATEST);
            pubsub.publish(EVENTS.ASSIGNMENT_CREATED, assignment);
            resolve();
          }
        })
        .fail(reject);
    });
}
